import { gql } from "graphql-request";

export const READ_TENANT_USERS = gql`
  query ReadTenantUsers($tenantId: ID!) {
    readTenantUsersByTenant(tenantId: $tenantId) {
      id
      userId
      displayName

      user {
        id
        firstName
        lastName
        email
        hourlyRate
      }
    }
  }
`;

export const READ_TENANT_USERS_BY_TENANT = gql`
  query ReadTenantUsersByTenant($tenantId: ID!) {
    readTenantUsersByTenant(tenantId: $tenantId) {
      id
      userId
      tenantId
      accessRole
      displayName
      archivedAt
      user {
        id
        firstName
        lastName
        email
        hourlyRate
        verifiedEmail
        role
        tenantID
        contactID
        notes
        invitedBy
        createdAt
        updatedAt
        archivedAt
      }
    }
  }
`;